export default __webpack_public_path__ + "static/media/plus-icon.e5162b0c.svg";